import axios from 'axios';
import Cookies from 'js-cookie';

const apiUrl = process.env.REACT_APP_API_URL;

export const getSelf = async() => {
  const { token } = Cookies.get();

  try {
    const response = await axios.get(`${apiUrl}/admin/self`, 
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer "+token,
        }
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
}

export const putSelf = async(data) => {
  const { token } = Cookies.get();

  try {
    const response = await axios.put(`${apiUrl}/admin/self`, 
      data,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer "+token,
        }
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
}

export const putSelfPassword = async(data) => {
  const { token } = Cookies.get();

  try {
    const response = await axios.put(`${apiUrl}/admin/self/password`, 
      data,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer "+token,
        }
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
}